import { useEffect, useState } from 'react';
import { ComponentErrorBoundary } from '@app/utilities';
import { Brand } from '@app/models';
import { BrandEditForm } from './BrandEditForm';

export function AddUpdateBrand({ selectedBrand }: { selectedBrand: Brand }) {
  const [brand, setBrand] = useState<Brand>();
  useEffect(() => {
    if (!selectedBrand) {
        setBrand(null);
      return;
    }
    setBrand({
      ...selectedBrand
    });
  }, [selectedBrand]);

  return (
    <ComponentErrorBoundary>
      <div className={'ui segment'}>
        <BrandEditForm key={JSON.stringify(brand)} brand={brand}></BrandEditForm>
      </div>
    </ComponentErrorBoundary>
  );
}
